import Welcome from "../components/Welcome/Authentication/Signup";

const HomePage = () => {
    return (
        <Welcome />
    );
};


export default HomePage;